import React, { useMemo, useState, useEffect } from 'react';
import apiClient from '../api/client';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

export default function DMDMfgs() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saveError, setSaveError] = useState('');

    const columns = useMemo(
        () => [
            {
                accessorKey: 'product_maker',
                header: 'Manufacturer',
                enableEditing: false,
                size: 250,
            },
            {
                accessorKey: 'discount',
                header: 'Discount',
                size: 150,
            },
        ],
        []
    );
        
    const getDMDMfgs = async () => {
        try {
            const res = await apiClient.get('/dmdmfgs');
            setData(res.data || []);
        } catch (error) {
            console.error('Error fetching DMD MFGs:', error);
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveMfg = async ({ values, row, table }) => {
        const discount = Number(values.discount);
        if (values.discount === '' || Number.isNaN(discount) || discount >= 1 || discount < 0) {
            setSaveError('Discount must be a decimal between 0 and 1 (for example 0.25 for 25%).');
            return;
        }
        setSaveError('');

        try {
            const url = '/dmdmfgs/' + encodeURIComponent(row.original.product_maker);
            await apiClient.post(url, { discount: discount.toString() });
            table.setEditingRow(null);
            getDMDMfgs();
        } catch (error) {
            console.error('Error updating DMD MFG:', error);
            setSaveError(`Could not save the discount for ${row.original.product_maker}. Please try again.`);
        }
    };

    const table = useMaterialReactTable({
        columns,
        data,
        muiPaginationProps: {
            rowsPerPageOptions: [15, 30, 50],
            showFirstButton: true,
            showLastButton: true,
        },
        createDisplayMode: 'row',
        editDisplayMode: 'row',
        enableEditing: true,
        initialState: { pagination: { pageSize: 15, pageIndex: 0 } },
        state: { isLoading: loading },
        onEditingRowSave: handleSaveMfg,
        onEditingRowCancel: () => setSaveError(''),
        renderEmptyRowsFallback: () => (
            <Box sx={{ p: 5, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                    No DMD Manufacturers found.
                </Typography>
            </Box>
        ),
        muiTablePaperProps: {
            elevation: 0,
            sx: {
                bgcolor: 'background.paper',
                border: 1,
                borderColor: 'divider',
                borderRadius: 2,
                boxShadow: 'none',
            },
        },
    });

    useEffect(() => {
        getDMDMfgs();
    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                    DMD Manufacturers
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Manage manufacturer discounts and catalog discount pricing
                </Typography>
            </Box>

            {saveError && (
                <Alert severity="error" onClose={() => setSaveError('')} sx={{ mb: 2, borderRadius: 2 }}>
                    {saveError}
                </Alert>
            )}

            <MaterialReactTable table={table} />
        </Box>
    );
}